import React from 'react'
import injectSheet from 'react-jss'
import styles from './create-dialog.styles'
import { Modal, ModalHeader, ModalFooter } from 'pobble-components/dist/modal'
import SlideForm from '../slide-form/slide-form'
import Button from 'pobble-components/dist/button'

const WordBankSlideCreateDialog = ({
  classes,
  modalOpened,
  onChange,
  onClose,
  onSubmit,
  onLinkChange,
  disableSubmit
}) => {
  return (
    <Modal closeButton isOpen={modalOpened} requestClose={onClose}>
      <ModalHeader>Add word bank slide</ModalHeader>
      <SlideForm
        onSubmit={onSubmit}
        footer={() => (
          <ModalFooter alignRight>
            <Button tall simple action={onClose}>
              Cancel
            </Button>
            <Button tall type="submit">
              Create slide
            </Button>
          </ModalFooter>
        )}
      />
    </Modal>
  )
}

export default injectSheet(styles)(WordBankSlideCreateDialog)
